import React, {useState , useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Modal, Button } from "react-bootstrap";

import "./BookingSteps.css";
import { toast } from "react-toastify";


const FinalStepBooking = () => {
  const [agree, setAgree] = useState(true);
 
  const navigate = useNavigate();

  const [property , setProperty] = useState({})
  const [BooingDate , setBooingDate] = useState({})

  const [showPopup, setShowPopup] = useState(false);

  const [show, setShow] = useState(false);




    const [agree1, setAgree1] = useState(false);
  const [loading, setLoading] = useState(false);





  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

    const steps = [
    { id: 1, label: "Your Selection" },
    { id: 2, label: "Your Details" },
    { id: 3, label: "Finish Booking" },
  ];


  useEffect(() => {
    window.scrollTo(0, 0);
    let property1 = JSON.parse(localStorage.getItem("Selected_Room"))
    let BooingData = JSON.parse(localStorage.getItem("BookingDate"))
    setProperty(property1)
    setBooingDate(BooingData)
    console.log(property1,BooingData)
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agree) {
      toast.success("Please agree to continue.");
      return;
    }


try {
    // 1. LocalStorage se data nikaalo
    const bookingDataInformation = localStorage.getItem("AllBookingData");
    const BookingDate = JSON.parse(localStorage.getItem("BookingDate"));
    const Selected_Room = localStorage.getItem("Selected_Room");

    if (!bookingDataInformation) {
      console.error("No booking data found in localStorage");
      return;
    }
    
    const bookingDataInformation1 = JSON.parse(bookingDataInformation);

    console.log(bookingDataInformation1.formData)


    const stored = localStorage.getItem("Selected_Room");

// 2. Parse karo
const parsed = JSON.parse(stored);

// 3. Room object lo
const room4 = parsed.Room;

// 4. Filtered object banao
const calendar76 = room4.calendar.map(item => ({
  startDate: item.startDate,
  endDate: item.endDate,
  status: item.status,
price: item.price != null 
    ? item.price 
    : (parsed.discount?.priceAfterDiscount != null 
        ? parsed.discount?.priceAfterDiscount 
        : room4.nightlyPrice)}));


const filteredRoom = {
  roomId: room4._id,
  calendar: calendar76 ,
  roomDetails: {
    roomType: room4.roomDetails.roomType,
    roomName: room4.roomDetails.roomName,
    customName: room4.roomDetails.customName,
    noOfRooms: room4.roomDetails.noOfRooms,
  },
  nightlyPrice: room4.nightlyPrice,
  tax: room4.tax,
  guests: room4.guests,
  bathrooms: room4.bathrooms,
  apartmentSize: room4.apartmentSize,
  sizeUnit: room4.sizeUnit,
  breakfast: room4.breakfast
  
//   {
//     "available": true,
//     "included": false,
//     "price": "1000",
//     "types": [
//         "American",
//         "Asian",
//         "Full English/Irish",
//         "Continental",
//         "Buffet",
//         "Halal",
//         "Italian"
//     ]
// }
  ,
  bathroomDetails: room4.bathroomDetails,
  childPolicy: room4.childPolicy,
  // _id: room4._id,
};



// Original property object
const property4 = parsed.property;

// Filtered Property object
const filteredProperty = {
  _id: property4._id,
  vendorId: property4.vendorId,
  propertyId: property4.propertyId,
  status: property4.status,
  category: property4.category,
  propertyName: property4.propertyName,
  address: property4.address,
  city: property4.city,
  zip: property4.zip,
  country: property4.country,
  location: {
    lat: property4.location.lat,
    lng: property4.location.lng,
  },
  checkIn: {
    from: property4.checkIn.from,
    until: property4.checkIn.until,
  },
  checkOut: {
    from: property4.checkOut.from,
    until: property4.checkOut.until,
  },
  acceptedPaymentMethods: property4.acceptedPaymentMethods,
  rules: {
    ageRestriction: property4.rules.ageRestriction,
    pets: property4.rules.pets,
    cancellationPolicy: property4.rules.cancellationPolicy,
  },
};


const parkingCost =
  bookingDataInformation1.formData.parking && parsed.property?.parking?.available
    ? parsed.property.parking.type === "paid"
      ? Number(parsed.property.parking.cost * parsed.stayDurationInDays || 0)
      : 0
    : 0;

// Parse breakfast cost
const breakfastCost =
  parsed.Room.breakfast?.available && parsed.Room.breakfast?.included === false
    ? Number((parsed.Room.breakfast.price * parsed.noOfRooms ) * parsed.stayDurationInDays|| 0)
    : 0;

// console.log(parsed.property?.parking,parsed.Room)


console.log(property4,)

const bookingData2 = {
  stayDurationInDays: parsed.stayDurationInDays,
  bookingDate: parsed.bookingDate,
  // totalPrice: parsed.totalPrice,
  totalPrice:(parsed.totalPrice || 0) + parkingCost + breakfastCost,
  noOfRooms: parsed.noOfRooms,
  taxs: parsed.taxs,         // localstorage me 'taxes' tha, tumne 'taxs' likha
  discountApplied: parsed.discountApplied ? true : false,
  // discount: parsed.discountApplied ? parsed.discountApplied : null,
};

const BookingDate7 = {
  destination: BookingDate.destination,
  checkIn: BookingDate.checkIn,
  checkOut: BookingDate.checkOut,
  // numberOfRooms: BookingDate.rooms,
  numberOfRooms: parsed.noOfRooms,
  numberOfAdults: BookingDate.adults,         // localstorage me 'taxes' tha, tumne 'taxs' likha
  numberOfChildren: BookingDate.children,         // localstorage me 'taxes' tha, tumne 'taxs' likha
  selectedOption: BookingDate.selectedOption,         // localstorage me 'taxes' tha, tumne 'taxs' likha

};


const bookingDataInformation2 = {
  propertyId:property4._id,
  vendorId:property4.vendorId,
  firstName: bookingDataInformation1.formData.firstName,
  lastName: bookingDataInformation1.formData.lastName,
  email: bookingDataInformation1.formData.email,
  address: bookingDataInformation1.formData.address,
  city: bookingDataInformation1.formData.city,
  zipCode: bookingDataInformation1.formData.zip || bookingDataInformation1.formData.zipCode,
  country: bookingDataInformation1.formData.country,
  phoneCode: bookingDataInformation1.formData.phoneCode,
  phoneNumber: bookingDataInformation1.formData.phoneNumber,
  bookingFor: bookingDataInformation1.formData.bookingFor,
  workTravel: bookingDataInformation1.formData.workTravel,
  shuttle: bookingDataInformation1.formData.shuttle === "on" ? true : false,
  carRental: bookingDataInformation1.formData.carRental === "on" ? true : false,
  taxi: bookingDataInformation1.formData.taxi === "on" ? true : false,
  // parking: bookingDataInformation1.formData.parking === "on" ? true : false,
  // parking: parsed.property.parking.type === "free" ? true :  bookingDataInformation1.formData.parking ,
  parking: parsed.property.parking.type === "free" ? true :  false ,
  specialRequest: bookingDataInformation1.formData.specialRequest || null,
  arrivalTime: bookingDataInformation1.formData.arrivalTime || null,
  isCribAvailable: bookingDataInformation1.formData.isCribAvailable === "on" ? true : false,
  noOfCribs: Number(bookingDataInformation1.formData.noOfCribs) || 0,
  isExtraBedAvailable: bookingDataInformation1.formData.isExtraBedAvailable === "on" ? true : false,
  noOfExtraBeds: Number(bookingDataInformation1.formData.noOfExtraBeds) || 0,
};

console.log(bookingDataInformation2)

const prefix = "RSV-";

  // YYMMDD format
  const now = new Date();
  const datePart =
    now.getFullYear().toString().slice(2) +
    String(now.getMonth() + 1).padStart(2, "0") +
    String(now.getDate()).padStart(2, "0");

  // Secure random part (4 chars)
  const randomPart = crypto
    .getRandomValues(new Uint32Array(1))[0]
    .toString(36)
    .substring(0, 4)
    .toUpperCase();

  // Combine: VEN-YYMMDD + Random (≈ 14–15 chars total)
  const Booking_Id =  `${prefix}${datePart}${randomPart}`;

const payload = {
  // ...BookingDate,
//  ...Selected_Room,
    "bookingId": Booking_Id,
...bookingDataInformation2,
// ...bookingDataInformation1.formData,
  rooms: [filteredRoom],
  ...bookingData2,
  property : filteredProperty,
    "isPaid": false,
    "paymentType": "through-vendor", 
     "customerRequirements": {   ...BookingDate7   }
};


console.log(payload)

//   fetch("https://striking-dedication-production.up.railway.app/api/v1/user/bookings", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ 
// ...payload
// }),
//   })
//     .then((res) => res.json())
//     .then((data) => {
//       console.log("Server Response:", data);
   

//         setLoading(true);
//     // Simulate API / booking confirm delay

//          setTimeout(() => {
//       setLoading(false);
//       toast.success("Booking completed successfully!");
//       navigate(`/confirmation/${Booking_Id}`)

//       // yaha redirect bhi kar sakte ho e.g. window.location.href = "/success"

//     }, 3000);

//     })
//     .catch((err) => {
//       console.error("Error in fetch:", err);
//     });









setLoading(true);

fetch("https://striking-dedication-production.up.railway.app/api/v1/user/bookings", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ ...payload }),
})
  .then((res) => res.json())
  .then((data) => {
    setLoading(false); // stop loading spinner immediately when response comes

    if (data.success) {
      // Booking successful
      toast.success("Booking completed successfully!");
      localStorage.setItem("BookingDetail",JSON.stringify(data.data))
      navigate(`/confirmation/${Booking_Id}`);
    } else {
      // Validation or server error
      alert(`${data.message || "Something went wrong"}`);
    }
  })
  .catch((err) => {
    setLoading(false); // stop loading even if fetch fails
    console.error("Error in fetch:", err);
    toast.success("Network error: Unable to complete booking. Please try again.");
  });











    // redirect or API call yaha kar sakte ho


     } catch (error) {
    console.error("Error submitting booking:", error);
  }

  };

  return (

     <div>
      <br />
<div className="steps-container">
      {steps.map((step, index) => (
        <div key={step.id} className="step-item">
          <div
            className={`step-circle ${
              3 >= step.id ? "active" : ""
            }`}
          >
            {step.id}
          </div>
          <span
            className={`step-label ${
              3 >= step.id ? "active-label" : ""
            }`}
          >
            {step.label}
          </span>
          {index < steps.length - 1 && (
            <div
              className={`step-line ${
                3 > step.id ? "active-line" : ""
              }`}
            ></div>
          )}
        </div>
      ))}
    </div>


      <div className="container">
        <div className="row">
          <div className="col-lg-3">

  <div className="Room_booking-summary">

    {/* Hotel Info */}
        <div className="Room_hotel-card">
        <img
            src={property.property?.images[0]}
            alt="Hotel"
            className="Room_hotel-img"
        />
        <div className="Room_hotel-info">
            <span>{"★".repeat(property.property?.stars || 4)}</span>
            <h5>{property.property?.propertyName}</h5>
            <p className="Room_hotel-location">{property.property?.address}</p>
            <span className="Room_hotel-rating"> <span>4.6</span>  Pleasant · 606 reviews</span>
        </div>
        </div>
      <hr/>
        {/* Booking Details */}
        <div className="Room_card-box">
        <h6>Your booking details</h6>
        <div className="d-flex justify-content-between">
            <div style={{borderRight:"1px solid grey",width:"50%"}}>
            <p className="Room_title">Check-in</p>
            <p className="Room_para">{BooingDate ? new Date(BooingDate.checkIn).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.startDate}
              {/* Mon, Sep 22, 2025 */}
              </p>
            {/* <p className="Room_para1">{property.property?.checkIn.from}12:30 PM – {property.property?.checkIn.until}2:00 PM</p> */}
            </div>
            <div style={{paddingLeft:"15px"}}>
            <p className="Room_title">Check-out</p>
            <p className="Room_para">{BooingDate? new Date(BooingDate.checkOut).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.endDate}
              {/* Mon, Sep 22, 2025 */}
              </p>
            {/* <p className="Room_para1">{property.property?.checkOut.from} 12:00 PM – {property.property?.checkOut.until}1:30 PM</p> */}
            </div>
        </div>
        <hr />
        <h6>You selected</h6>


{/* <p><strong>1 night, 1 room for 2 adults</strong></p> */}
        {/* <p>
  <strong>
    {Math.ceil(
      (new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)
    )}{" "}
    night{Math.ceil((new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)) > 1 ? "s" : ""},{" "}
    {BooingDate?.rooms} room{BooingDate?.rooms > 1 ? "s" : ""} for {BooingDate?.adults} adult{BooingDate?.adults > 1 ? "s" : ""}
    {BooingDate?.children > 0 ? ` and ${BooingDate?.children} child${BooingDate?.children > 1 ? "ren" : ""}` : ""}
  </strong>
</p> */}


      <p>
  <strong>
    {Math.ceil(
      (new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)
    )}{" "}
    night{Math.ceil((new Date(BooingDate?.checkOut) - new Date(BooingDate?.checkIn)) / (1000 * 60 * 60 * 24)) > 1 ? "s" : ""},{" "}
    {property?.noOfRooms} room{property?.noOfRooms > 1 ? "s" : ""} for {BooingDate?.adults} adult{BooingDate?.adults > 1 ? "s" : ""}
    {BooingDate?.children > 0 ? ` and ${BooingDate?.children} child${BooingDate?.children > 1 ? "ren" : ""}` : ""}
  </strong>
</p>

        <p>{property?.stayDurationInDays} night{property?.noOfRooms > 1 ? "s" : ""}  × {property.Room?.roomDetails.customName}</p>
        <a style={{color : "blue"}} href="/searchresults">Change your selection</a>
        </div>

        {/* Price Summary */}
       <div className="Room_card-box price-box">
        <h6>Your price summary</h6>
        <div className="Room_price-main" style={{fontSize:"22px"}}>
            <span className="Room_price-label"> <b>Price</b> </span>
            <span className="Room_price-amount"> <b style={{marginLeft:"5px"}}>PKR {property?.totalPrice}</b> </span>
        </div>
        <p className="Room_tax-note">+PKR {property?.taxs} taxes and fees<br/>
        {/* In property currency: US$135 */}
        </p>
        </div>

        {/* Price Info */}
        <div className="Room_card-box">
        <h6>Price information</h6>
        <ul className="Room_price-info">
            <li>Excludes PKR {property?.taxs} in taxes and fees</li>
            <li>15% Tax — PKR {property?.taxs}</li>
            {/* <li>This price is converted to show you the approximate cost in PKR. You’ll pay in USD. The exchange rate might change before you pay.</li> */}
            {/* <li>Keep in mind your card issuer may charge a foreign transaction fee.</li> */}
        </ul>
        </div>


        <div className="Room_card-box">
        <h6>Your payment schedule
</h6>
        <ul className="Room_price-info">
            <li style={{color :"#008009"}}>No payment today. You'll pay when you stay.
</li>
            {/* <li>15% Tax — PKR 5,697.85</li>
            <li>This price is converted to show you the approximate cost in PKR. You’ll pay in USD. The exchange rate might change before you pay.</li>
            <li>Keep in mind your card issuer may charge a foreign transaction fee.</li> */}
        </ul>
        </div>

    </div>






          </div>
          <div className="col-lg-9">












    <div className="info-card p-4 border rounded bg-white">
      {/* No Payment Required Section */}
      <div className="mb-3 p-3 border rounded bg-light">
        <h6 className="fw-bold">No payment details required</h6>
        <p className="mb-0">
          Your payment will be handled by <strong>{property.property?.propertyName}</strong>, 
          so you don’t need to enter any payment details for this booking.
        </p>
      </div>

      {/* Checkbox */}
      <div className="form-check mb-3">
        <input
          type="checkbox"
          id="marketing"
          className="form-check-input"
          checked={agree}
          onChange={(e) => setAgree(e.target.checked)}
        />
        <label htmlFor="marketing" className="form-check-label">
          I agree to receiving marketing emails from Yovho.com, including promotions, 
          personalized recommendations, rewards, travel experiences, and updates about Yovho.com’s 
          products and services.
        </label>
      </div>

      {/* Small note */}
      <small className="text-muted d-block mb-3">
        By signing up, you allow us to tailor offers and content to your interests by monitoring how 
        you use Yovho.com through tracking technologies. Unsubscribe anytime through your account 
        settings or the link in any marketing email. Read our <a href="#">privacy policy</a>.
      </small>

      {/* Terms note */}
      <p className="small mb-3">
        Your booking is directly with <strong>{property.property?.propertyName}</strong> and by completing this 
        booking you agree to the{" "}
              <p style={{cursor :"pointer"}} onClick={(e) => { e.preventDefault(); handleShow(); }}>
        booking conditions
      </p>
        <a href="#">booking conditions</a>,{" "}
        <a href="#">general terms</a>, and{" "}
        <a href="#">privacy policy</a>.
      </p>

      {/* Complete booking button */}
      <button
        className="btn btn-primary w-100 fw-bold"
        onClick={handleSubmit}
      >
        Complete booking
      </button>

      {/* Footer link */}
      <div className="text-center mt-3">
        <p  style={{cursor :"pointer"}} onClick={(e) => { e.preventDefault(); handleShow(); }} className="small"> What are my booking conditions?</p>
      </div>
    </div>















<Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Booking Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>{property?.stayDurationInDays} × "{property.Room?.roomDetails.customName}"</h6>

          {/* Cancellation */}
          <div className="mb-3">
            <h6 style={{fontWeight:"bold"}}>Cancellation</h6>
            <p className="text-success fw-bold">
              ✓ Free cancellation before {BooingDate ? new Date(BooingDate.checkIn).toLocaleDateString("en-US", { weekday: "short" }) : ""}, {property.bookingDate?.startDate &&
  new Date(property.bookingDate.startDate)
    .toLocaleDateString("en-GB")
    .replace(/\//g, "--")}

            </p>
            <p>
              You can cancel for free until 1 day before arrival. You’ll be
              charged the total price of the reservation if you cancel within 1
              day of arrival. If you don’t show up, the no-show fee will be the
              same as the cancellation fee.
            </p>
            <small className="text-muted">
              Cancellation deadlines are in the property’s local time.
            </small>
          </div>

          {/* How to cancel */}
          <div className="mb-3">
            <h6 style={{fontWeight:"bold"}}>How to cancel</h6>
            <p>
              You can use the link in the confirmation email to cancel your
              booking.
            </p>
          </div>

          {/* Prepayment */}
          <div className="mb-3">
            <h6 style={{fontWeight:"bold"}}>Prepayment</h6>
            <p className="text-success fw-bold">
              ✓ No prepayment needed – pay at the property
            </p>
            <p>No prepayment is needed.</p>
          </div>

          {/* Taxes */}
          <div>
            <h6 style={{fontWeight:"bold"}}>Taxes and service charges</h6>
            <p>
              15% TAX is excluded. A City tax is not applicable. A Property
              service charge is not applicable.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
















<div>
      

      {/* Popup Modal */}
      {loading && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="loader"></div>
            <h3>Confirming</h3>
            <p>your booking!</p>
          </div>
        </div>
      )}

      {/* CSS */}
      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .popup-box {
          background: #fff;
          padding: 30px;
          border-radius: 12px;
          text-align: center;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          width: 260px;
        }
        .loader {
          border: 6px solid #f3f3f3;
          border-top: 6px solid #0071c2;
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
          margin: 0 auto 15px;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
















          </div>
        </div>
      </div>
    </div>



  );
};

export default FinalStepBooking;
